// extracted by mini-css-extract-plugin
export var animationWrapper = "About-module--animationWrapper--fe7b8";
export var animation = "About-module--animation--23c30";
export var layout = "About-module--layout--358f1";
export var title = "About-module--title--f1024";
export var content = "About-module--content--f93ed";
export var item = "About-module--item--07eb5";
export var itemNumber = "About-module--itemNumber--4586f";
export var itemDescription = "About-module--itemDescription--2f89e";